import { type Enum } from '@webapp/infrastructure/types/Enum'

export const PrimaryCategoryConfigDetailPageTabTypes = {
  DETAILS: 'details',
  DEPARTMENTS: 'departments',
  USERS: 'users',
} as const

export type PrimaryCategoryConfigDetailPageTabType = Enum<
  typeof PrimaryCategoryConfigDetailPageTabTypes
>

export interface PrimaryCategoryConfigDetailPageParams {
  id: string
  tab: PrimaryCategoryConfigDetailPageTabType
}

export const PrimaryCategoryConfigListPageTabTypes = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
} as const

export type PrimaryCategoryConfigListPageTabType = Enum<
  typeof PrimaryCategoryConfigListPageTabTypes
>

export interface PrimaryCategoryConfigListPageParams {
  tab: PrimaryCategoryConfigListPageTabType
}
